import { DaycareColors } from '@/types/Daycare'

export function setUserInterfaceDaycareColors(colors: DaycareColors) {
    document.documentElement.style.setProperty('--daycare-dark', colors.daycareDark)
    document.documentElement.style.setProperty('--daycare-main', colors.daycareMain)
    document.documentElement.style.setProperty('--daycare-light', colors.daycareLight)
    document.documentElement.style.setProperty('--daycare-extra-light', colors.daycareExtraLight)
    document.documentElement.style.setProperty('--parent-dark', colors.parentDark)
    document.documentElement.style.setProperty('--parent-main', colors.parentMain)
    document.documentElement.style.setProperty('--parent-light', colors.parentLight)
    document.documentElement.style.setProperty('--parent-extra-light', colors.parentExtraLight)
}
